export default __webpack_public_path__ + "static/media/warning-icon-file-upload.98aae86b.svg";